import * as React from 'react';

import { ComposableMap, Geographies, Geography, ZoomableGroup } from "react-simple-maps";
import ChinaJson from './Assets/china.json'
import Typography from '@mui/material/Typography';
import {
    Marker
  } from "react-simple-maps";
import favicon from './Assets/logo.png' 


import Box from '@mui/material/Box';
import Popover from '@mui/material/Popover';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';

import Toolbar from '@mui/material/Toolbar';
import AppBar from '@mui/material/AppBar';

import Tooltip from '@mui/material/Tooltip';
import Paper from '@mui/material/Paper';

import '../CSS/Marker.css';
import MapAccordion from './MapAccordion';
import MapInfoCard from './MapInfoCard';
import MapMarker from './MapMarker.js';

import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';

function Map(props) {

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [geoUrl, setGeoUrl] = React.useState('./Assets/china.json');
  const [position, setPosition] = React.useState({ coordinates: [0, 0], zoom: 1 });
  const [province, setProvince] = React.useState("");
  const [expanded, setExpanded] = React.useState(false);
  const [regionChosen, setRegionChosen] = React.useState("");
  const [regionIndex, setRegionIndex] = React.useState(0);
  const [curHeight, setCurHeight] = React.useState(window.innerHeight);
  const [curWidth, setCurWidth] = React.useState(window.innerWidth);
  const [center, setCenter] = React.useState([ 111.27, 23.48 ]);
  const [curZoom, setCurZoom] = React.useState(5);
  const [value, setValue] = React.useState(0);
  const [width, setWidth] = React.useState(window.innerWidth);

  function handleWindowSizeChange() {
      setWidth(window.innerWidth);
  }
  const isMobile = width <= 768;

  window.addEventListener('resize', function(event) {
        setCurHeight(window.innerHeight)
        setCurWidth(window.innerWidth)
    }, true);

    React.useEffect(() => {
      window.addEventListener('resize', handleWindowSizeChange);
      return () => {
          window.removeEventListener('resize', handleWindowSizeChange);
      }
    }, []);

  const handleChange = (panel, isExpanded, targetId) => {
    // TODO: also update regionIndex from here.
    console.log(panel, isExpanded, "targetId:" + targetId)
    if (targetId !== "infoIcon") {
      setExpanded(isExpanded ? panel : false);
    }
  };

  const handleClick = (anchorEl, id) => {
    console.log("HANDLECLICK")
    setAnchorEl(anchorEl);
    setRegionChosen(id);
    setRegionIndex(0);
  };

  const handleSelect = (elementId, rIndex) => {
    if (isMobile) {
      setValue(1);
    }
    var el = document.getElementById(elementId)
    setAnchorEl(el);
    setRegionChosen(elementId);
    setRegionIndex(rIndex);
  }

  const handleClose = () => {
    console.log("HANDLECLOSE")
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  
  const allMarkers = {
    "YueYang": [
      113.11653926215769,
      29.331167523662316
    ],
    "Yunnan":[101.0652,25.1807],
    "GuangXi":[ 111.27, 23.48 ],
    "Taiwan":[ 121.00949, 23.89295],
    "WuYi":[118.3008,25.9277],
    "FuDing":[120.228,27.361],
    // "SuZhou":[120.5562,31.3270],
    "XiHu":[120.095885, 30.22463],
    
    "QiMen":[117.71301672750161,  29.85217046771895] 
    };

  const accordionInfo = [
    {
  "summary":"Oolong",
  "dropColor":"#DC3",
  "panelId":"ppds33", 
  "teas":[{"name":"High Mountain Oolong", "region":"Taiwan", "index":1},
  {"name":"DaHongPao", "region":"WuYi", "index":1}
]},
  {
  "summary":"Dark",
  "dropColor":"brown",
  "panelId":"pp33", 
  "teas":[{"name":"PuErh", "region":"Yunnan", "index":0}, 
  {"name":"LiuBao", "region":"GuangXi", "index":0}]},
  {
  "summary":"White",
  "dropColor":"#EEA",
  "panelId":"pp34", 
  "teas":[{"name":"Shoumei", "region":"FuDing", "index":0}, 
  {"name":"Silver Needles", "region":"FuDing", "index":1}]},
  {
  "summary":"Green",
  "dropColor":"#AD2",
  "panelId":"pp", 
  "teas":[{"name":"LongJing", "region":"XiHu", "index":0},
  {"name":"BiLuoChun", "region":"Taiwan", "index":0}]},
  {
  "summary":"Red (Black)",
  "dropColor":"#ffa31a",
  "panelId":"pp1", 
  "teas":[{"name":"Lapsang Souchong", "region":"WuYi", "index":0}, 
  {"name":"QiMen Red", "region":"QiMen", "index":0},
  {"name":"DianHong", "region":"Yunnan", "index":1}]},
  {
  "summary":"Yellow",
  "dropColor":"#FE0",
  "panelId":"pp2", 
  "teas":[{"name":"YueYang Yellow Tea", "region":"YueYang", "index":0}]},
  ];

  return (
    <div>
<Box class="maindiv" sx={{ width:'100%', height:'100%', backgroundColor:'white',}}>
        <AppBar position="fixed" sx={{background:'transparent', boxShadow:'none'}} >
            <Toolbar>
                <Typography variant="h4" component="div" 
                sx={{ color:'black', flexGrow: 1, opacity:'100%', ml:6, mt:6,  }}>
                    Teas of China
                </Typography>
            </Toolbar>
        </AppBar>

    
    <ComposableMap 
    projection="geoMercator"
    projectionConfig={{
        scale: 100,
      }}

    //    and window. innerHeight
    width={curWidth / 2.0}
    height={curHeight / 2}
      >
    <ZoomableGroup
        onMoveEnd={({ coordinates, zoom }) => {
            setCurZoom(zoom);
        }}
        onMoveStart={({ coordinates, zoom }) => {
            setCurZoom(zoom);
        }}
        // onMove={({ coordinates, zoom }) => {
        //     setCurZoom(zoom);
        // }}
        center={[ 105.27, 28.48 ]}
        zoom={5}
        minZoom={2.5}
        maxZoom={15}
        translateExtent={[[-1000, -1000], [900, 900]]}>
      <Geographies geography={ChinaJson}>
        {({ geographies }) =>
          geographies.map((geo) => (
            <Tooltip title={geo.properties.name} followCursor>
            <Geography 
            key={geo.rsmKey} 
            geography={geo}
            strokeWidth={0.3}
            stroke="#ffda8f"
            onClick={(e) => setProvince(geo.properties.name)}
            fill={province === geo.properties.name ? "#FFF" : "#000"}
            style={{
                default: { fill: "#2b9900", outline:'none' },
                hover: { fill: "#a9ff7a", outline:'none' },
                pressed: { fill: "#000", },
            }} />
            </Tooltip>
          ))
        }
      </Geographies>

      {/* liubao [ 111.27, 23.48 ] */}

      {Object.keys(allMarkers).map((key, index) => (
            <MapMarker
            coordinates={allMarkers[key]}
            regionChosen={regionChosen}
            name={key}
            handleClick={handleClick}
            zoom={curZoom}
          />
          ))}

      {/* Sanxia [121.4139, 24.9108 ] */}
      {/* [118.3008,25.9277] wuyi */}
      {/* [120.0254,23.5986] alishan */}
      {/* [120.228,27.361] fuding */}
      {/* [117.71301672750161,  29.85217046771895] qimen */}

      <Marker coordinates={ [104, 36] } fill="#777"> 
            <text fill="black"
            font-size={4}
             textAnchor='middle' y="-2" >Too cold to grow tea</text> 
            <line x1="-70" y1="0" x2="70" y2="0" strokeDasharray="2, 2" stroke="black" strokeWidth={0.5}/>
      </Marker>

      
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          
        slotProps={{ paper:{style:{maxWidth:'300px', alignItems:'center', justifyContent:"center"} } }}
      >
        {/* <Box sx={{justifyContent:'center', alignItems:'center' }}>
            <img src={favicon} align='center' width='150px' sx={{ml:"auto", mr:"auto"}} />
            <Typography>CUNTTTTTTTTTTT</Typography>
        </Box> */}
        
            <MapInfoCard
                regionChosen={regionChosen}
                regionIndex={regionIndex}
                setRegionIndex={setRegionIndex}
            // TODO: add props for page and index
            />
      </Popover>

      </ZoomableGroup>
    </ComposableMap>     
    </Box>

    

    <Accordion sx={{width:"20%", position:'fixed', bottom:0, right:0, display: { xs: 'none', md: 'inline' }}}> 
        <AccordionSummary
          // expandIcon={<ExpandMoreIcon />}
          // aria-controls="panel1a-content"
          // id="panel1a-header"
        >
          <Typography variant="h6" sx={{background:'none'}}>
                {province === "" ? "Click on a province" : province}
            </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{background:'none'}}>
            {/* TODO: display all teas within province? */}
                {province}
            </Typography>
        </AccordionDetails>
    </Accordion>

    {value % 2 == 0 && 
    <Box sx={{width:isMobile ? "100%" : 300, position:'fixed', 
    bottom: isMobile ? 55 : 0, left:0,}}>

      {accordionInfo.map((value, index) => (
        <MapAccordion 
        typeIndex={index}
        handleSelect={handleSelect} 
        handleChange={handleChange} 
        expanded={expanded}
        summary={value.summary}
        dropColor={value.dropColor}
        teas={value.teas}
        panelId={value.panelId}
        />
      ))}

    </Box>
    }

    <Box sx={{ width: 500 }}>
      <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} elevation={3}>
        <BottomNavigation 
          showLabels
          sx={{display:{xs: "flex", md:"none"}}}
          value={ value % 2 }
            onChange={(event, newValue) => {
              setValue(value + 1);
            }}
          >
          <BottomNavigationAction label="Show Tea Types"  
             icon={ value % 2 === 0 ? <VisibilityIcon /> : <VisibilityOffIcon/>} />
          {/* VisibilityOffIcon */}
        </BottomNavigation>
      </Paper>
    </Box>

    </div>
  )
}

export default Map;